module.exports = {"meta":{"name":"@lmig/lmds-tokens","author":"Liberty Mutual Insurance Group","version":"1.6.0","repository":"https://github.com/lmigtech/grm-design-system.git","license":"UNLICENSED","description":"LMIG design tokens - breakpoint"},"lmig":{"breakpoint":{"base":{"min":0,"max":"479px","raw":0},"sm":{"min":"480px","max":"767px","raw":480},"md":{"min":"768px","max":"959px","raw":768},"lg":{"min":"960px","max":"1279px","raw":960},"xl":{"min":"1280px","raw":1280}}}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-tokens/dist/json/core/breakpoint.json
// module id = 940
// module chunks = 0